import { MDText } from 'i18n-react';

import LocalTexts from '../VehicleProfilingTexts.json';

const LocalT = new MDText(LocalTexts);

export const SERVICE_HISTORY_KEY = 'history';
export const SERVICE_UPLOAD_KEY = 'upload';
export const SERVICE_PHOTOS_KEY = 'docs_service_history';

export const SERVICE_PATH = '/service';

export const getHistorySections = (text: any) : any[] => {
  const pages = text?.servicePage || {};
  return Object.entries(pages).filter(([, it]: [string, any]) => it.route);
};

export const ERROR_FILE_TYPE_COPY = LocalT.translate('confirmDetails.sections.serviceHistoryDetails.errors.kind.typeNotSupported') as string;
export const ERROR_FILE_TOO_LARGE = LocalT.translate('confirmDetails.sections.serviceHistoryDetails.errors.kind.sizeNotSupported') as string;
export const ERROR_FILE_HAS_MANY_PAGES = LocalT.translate('confirmDetails.sections.serviceHistoryDetails.errors.kind.tooManyPages') as string;

export const checkFileError = (str: string) =>
  [ERROR_FILE_TYPE_COPY, ERROR_FILE_TOO_LARGE, ERROR_FILE_HAS_MANY_PAGES].includes(str);

export const isSupportedFileSize = (fileSize: number, limit: number = 40) => fileSize < limit * 1024 * 1024;

export const SERVICE_HISTORY = Object.freeze({
  NO: 'no',
});
